import { WindowContainer } from "../interfaces/user.interface";

export class LoaderService {
    $ = WindowContainer.GetWindow().$;
    defaultMessage = 'Please wait while we load the page';

    constructor() {
        const loader = this.$('#mrg-loader');
        if (!loader.length) {
            const body = this.$('body');
            if (body) {
                body.append(`
                <div id='mrg-loader' style="display:none;">
                    <div class="loader-wrapper">
                        <div class="loader-inner ball-pulse centerText d-flex">
                            <div class="ball1"></div>
                            <div class="ball2"></div>
                            <div class="ball3"></div>
                        </div>
                        <p class="fs-1 mt-4 d-flex loader-message"></p>
                    </div>
                </div>`);
            }

        }
    }

    public show(hideBody = false, message = ''): void {
        const loader = this.$('#mrg-loader');
        if (loader.length) {
            if (message) {
                this.$('.loader-message').text(message);
            } else {
                this.$('.loader-message').text(this.defaultMessage);
            }

            setTimeout(() => {
                if (hideBody) {
                    this.$('.app-header').siblings().hide();
                    this.$('.app-main').siblings().hide();
                }

                this.$('#mrg-loader').fadeIn();
            });
        }
    }
    public hide(): void {
        setTimeout(() => {
            this.$('#mrg-loader').fadeOut();
            this.$('.app-header').siblings().fadeIn();
            this.$('.app-main').siblings().fadeIn();
        });
    }

    public showDefaultLoading(hideBody = false): void {
        this.show(hideBody, 'Loading...');
    }
}